import React, { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import { ShoppingCart, ReceiptText, UserPlus, Wallet, FileText, Truck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppContext } from "context";

/**
 * "+" Quick Create menu — deep links to common add-forms, access-gated.
 */
const QuickCreate = () => {
  const { access, settings } = useAppContext();
  const { t } = useTranslation(["common", "nav"]);
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState(null);

  const hasFy = !!settings?.fiscalYearId;

  const items = [
    {
      key: "sale",
      enabled: hasFy && access.posAccess,
      label: t("newSale", "New Sale"),
      icon: <ShoppingCart size={18} />,
      path: "pos",
    },
    {
      key: "csi",
      enabled: hasFy && access.salesInvoiceAccess && (access.salesInvoice?.create ?? true),
      label: t("newSalesInvoice", "New Direct Invoice"),
      icon: <ReceiptText size={18} />,
      path: "direct_invoicing/new",
    },
    {
      key: "customer",
      enabled: hasFy && access.customerAccess && (access.customer?.create ?? true),
      label: t("newCustomer", "New Customer"),
      icon: <UserPlus size={18} />,
      path: "customer_form",
    },
    {
      key: "expense",
      enabled: hasFy && access.expenseAccess,
      label: t("newExpense", "New Expense"),
      icon: <Wallet size={18} />,
      path: "expenses",
    },
    {
      key: "jv",
      enabled: hasFy && access.journalVoucherAccess,
      label: t("newJournalVoucher", "New Journal Voucher"),
      icon: <FileText size={18} />,
      path: "journal_voucher_form",
    },
    {
      key: "po",
      enabled: hasFy && access.stockAccess && access.stock?.create,
      label: t("newPurchaseOrder", "New Purchase Order"),
      icon: <Truck size={18} />,
      path: "purchase_order_form",
    },
  ].filter((i) => i.enabled);

  if (items.length === 0) return null;

  const go = (path) => {
    setAnchor(null);
    navigate(path);
  };

  return (
    <>
      <Tooltip title={t("create", "Create new")}>
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)} sx={{ color: "var(--gray-color)" }}>
          <AddRounded />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {items.map((i) => (
          <MenuItem key={i.key} onClick={() => go(i.path)} sx={{ minWidth: 230 }}>
            <ListItemIcon className="text-primary">{i.icon}</ListItemIcon>
            <ListItemText primary={i.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default QuickCreate;
